import { z } from 'zod';

export const CompanySearchResultSchema = z.object({
  name: z.string().optional(),
  domain: z.string().nullable().optional(),
});

export type CompanySearchResult = z.infer<typeof CompanySearchResultSchema>;
